var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallboxSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,0H8C6.3457031,0,5,1.3457031,5,3v26c0,1.6542969,1.3457031,3,3,3h16c1.6542969,0,3-1.3457031,3-3V3 C27,1.3457031,25.6542969,0,24,0z M25,29c0,0.5517578-0.4482422,1-1,1H8c-0.5517578,0-1-0.4482422-1-1V3 c0-0.5517578,0.4482422-1,1-1h16c0.5517578,0,1,0.4482422,1,1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,16c-3.3085938,0-6,2.6914062-6,6s2.6914062,6,6,6s6-2.6914062,6-6S19.3085938,16,16,16z M16,26 c-2.2060547,0-4-1.7939453-4-4s1.7939453-4,4-4s4,1.7939453,4,4S18.2060547,26,16,26z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 9.5,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallboxSmall);
export default __webpack_public_path__ + "static/media/wallbox--small.47ab03a1cd3fac0fb0238de9b65e6092.svg";
export { ForwardRef as ReactComponent };